import React, { useEffect } from 'react';
import { checkValue, getUniqueListBy } from 'src/components/common/helper';
import useCampaignByIdDynamic from '../../../expedia-deals/hotel/hooks/useCampaignByIdDynamic';
import { useBexApi } from '@shared-ui/bex-api-context';
import DealCardView from 'src/components/common/modules/v1/deal-fixtures/components/deal-card-view';
import { mockResponse } from 'src/components/common/modules/expedia-deals/hotel/hotel-data/mock/mock-response-campaginid';
import { CampaignProductType } from 'src/common/__generated__/api/types';

const DealCardByCampaignIds: React.FC = (props: any) => {
  const { context } = useBexApi();
  const initialVariables = {
    // Set your initial variables here
    userLocation: {},
    campaignId: '',
    // other variables...
  };

  const { hotelSearchData, updateVariables, fetchHotelData, isLoading } = useCampaignByIdDynamic(initialVariables);
  const { resetSearchResults, campaignId, enableTripAttach, enableLivePricing, regionId } = props;

  useEffect(() => {
    updateVariables(initialVariables);
    fetchHotelData();
  }, [resetSearchResults]);

  const moreDealsLink = '';

  const getHotelDataFetchProps = () => {
    const campaignByIdVariables = {
      context,
      campaignId: campaignId || '',
      enableTripAttach: enableTripAttach === 'True',
      pageNumber: 1,
      userLocation: {},
      displayPropertyCount: true,
      referrer: undefined,
      enableLivePricing: enableLivePricing === 'True',
      destinationId: regionId,
      productType: CampaignProductType.HOTEL
    };

    return campaignByIdVariables;
  };

  const handleClick = () => {
    updateVariables(getHotelDataFetchProps());
    setTimeout(() => {
      if (
        checkValue(hotelSearchData?.campaignRecommendations?.campaigns, true) &&
        checkValue(hotelSearchData?.campaignRecommendations?.campaigns[0].campaignId) &&
        checkValue(hotelSearchData?.campaignRecommendations?.campaigns[0].campaignId !== campaignId)
      )
        fetchHotelData();
    }, 10);
  };

  const shuffle = (array: any) => {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex > 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
  };

  const arrangeData = (dataArr: any) => shuffle(getUniqueListBy(dataArr, 'name')).slice(0, 2);

  let searchData = [];
  if (
    checkValue(!isLoading) &&
    checkValue(hotelSearchData) &&
    checkValue(hotelSearchData?.campaignRecommendations?.campaigns, true) &&
    checkValue(hotelSearchData.campaignRecommendations.campaigns[0].offers, true)
  ) {
    searchData = arrangeData(hotelSearchData.campaignRecommendations.campaigns[0].offers);
  } else if (
    // this is for testing -----------------------
    window?.location?.href?.indexOf('sandbox') > -1 &&
    checkValue(!isLoading) &&
    checkValue(hotelSearchData) &&
    !checkValue(hotelSearchData?.campaignRecommendations?.campaigns, true)
  ) {
    searchData = arrangeData(mockResponse?.offers);
  }

  return (
    <DealCardView
      {...{
        ...props,
        searchData,
        handleClick,
        moreDealsLink,
        isLoading,
        type: 'campaign',
      }}
    />
  );
};

export default DealCardByCampaignIds;
